import type { SaleWriteIntent } from "./changes";

/**
 * The intent of the saves that tell none, while a v2 flow has v1 code writing for it
 * (DISCOUNT_V2_PLAN.md §9.10, decision 119).
 *
 * A v2 write tells its intent on the action it dispatches (`changes.ts` › `withToldIntent`). The host's own
 * customise popup in v1's screens is v1's component, whose saves tell nothing, so the sale effects read
 * its add of a reward's item as a bill change and release the very reward a retie is moving (v1 armed
 * `skipNextBillChangeInvalidation()` before its own add for that reason). The discount flow says the intent
 * right before it opens that popup and takes its word back when the popup is done; every untold save in
 * between is heard as a told write (`saleEffectsV2.ts` › `runPromotionEffectsV2` asks).
 *
 * Not a one-shot: v1's popup may save more than once for one item (a size group's line is first added as a
 * placeholder, then replaced by the chosen variant), and each of those saves is the flow's.
 *
 * 🔴 A v1 BRIDGE (docs/V1_BRIDGES.md): it exists only because a v2 flow writes through v1 code. It goes when
 * no v2 flow does.
 */

let spokenFor: SaleWriteIntent | null = null;

/** Say the intent of every untold save from now on, or pass `null` to take the word back. */
export function tellUntoldWrites(intent: SaleWriteIntent | null): void {
  spokenFor = intent;
}

/** The intent a flow has spoken for the untold saves, now; `undefined` when none has. */
export function spokenIntent(): SaleWriteIntent | undefined {
  return spokenFor ?? undefined;
}
